import { graphql } from '../graphql/generated';

export const SENT_REQUESTS_QUERY = graphql(`
  query SentRequests($doctorId: ID!, $pageable: Pageable!, $filter: RequestFilter!) {
    sentRequests(doctorId: $doctorId, pageable: $pageable, filter: $filter) {
      entries {
        id
        createdAt
        sentAt
        sampledAt
        status
        comment
        ordersTruncated
        orders {
          id
          type
          number
          createdAt
          lab {
            id
            shortName
            identifier
          }
        }
        patientData {
          birthday
          city
          country
          email
          externalId
          firstName
          lastName
          gender
          zip
          svnr
          title
          street
          phone
          insuranceCode
          idCardAuthority
          idCardNumber
          idCardType
          insuranceCategory
          insuredPerson {
            phone
            street
            title
            svnr
            zip
            birthday
            gender
            firstName
            email
            country
            city
            lastName
          }
        }
        reorderable
        reorderableUntil
        createdByFirstName
        createdByLastName
        modifiedByFirstName
        modifiedByLastName
        sentByFirstName
        sentByLastName
      }
      hasMore
    }

    doctor(id: $doctorId) {
      id
      flipParamNames
    }
  }
`);
